import React, { useEffect, useState } from 'react';

const StundenImageSliderComponent = ({
    //type,
    //isOrigin,
    images,
    //setImages,
    //taetigkeitenImages,
    width,
    height,
    setPreviewImage = () => {},
    setPreviewShown = () => {},
    //setUpdatedImages,
    //setUpdatedIndex,
    //setIsChange
}) => {
    const [sliderImages, setSliderImages] = useState(images);
    const [currentSlide, setCurrentSlide] = useState(0);
    const totalSlides = images.length;

    useEffect(() => {
        setSliderImages(images);
        setCurrentSlide(0);
    }, [images]);

    useEffect(() => {}, [sliderImages]);

    const handleNextSlide = () => {
        if (sliderImages.length > 1) {
            setCurrentSlide((currentSlide + 1) % totalSlides);
        }
    };

    const handlePrevSlide = () => {
        if (sliderImages.length > 1) {
            setCurrentSlide((currentSlide - 1 + totalSlides) % totalSlides);
        }
    };

    // const handleDeleteSlide = () => {
    //
    //     setIsChange(false)
    //     const remainingSlides = [...sliderImages];
    //     if (type === "taetigkeiten") {
    //         if (remainingSlides.length > 1) {
    //             remainingSlides.splice(currentSlide, 1);
    //         } else {
    //             alert("Es muss mindestens ein Tätigkeit Bild sein.")
    //         }
    //     }
    //     setSliderImages(remainingSlides);
    //     setUpdatedImages(remainingSlides);
    //
    //     if (type === "taetigkeiten") {
    //         if (remainingSlides.length === 0) {
    //             let index = taetigkeitenImages.findIndex(innerArr => sliderImages.every(element => innerArr.includes(element)));
    //             setUpdatedIndex(index);
    //         } else {
    //             let index = taetigkeitenImages.findIndex(innerArr => remainingSlides.every(element => innerArr.includes(element)));
    //             taetigkeitenImages[index] = remainingSlides;
    //             setImages(taetigkeitenImages);
    //             setSliderImages(remainingSlides);
    //             setUpdatedIndex(index);
    //         }
    //
    //
    //     } else {
    //         setImages(remainingSlides);
    //     }
    //     const maxIndex = remainingSlides.length - 1;
    //     let nextIndex = currentSlide;
    //     if (nextIndex > maxIndex) {
    //         nextIndex = maxIndex;
    //     } else if (nextIndex < 0) {
    //         nextIndex = 0;
    //     }
    //     if (remainingSlides.length > 0) {
    //         nextIndex = nextIndex % remainingSlides.length;
    //     }
    //     setCurrentSlide(nextIndex);
    //
    // };

    const sliderStyles = {
        position: 'relative',
        width,
        height,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
    };
    
    const imgStyles = {
        width: 'auto',
        height: '50vh',
        objectFit: 'cover',
        cursor: 'zoom-in',
        aspectRatio: 1,
        overflow: 'hidden',
    };

    const btnStyles = {
        // position: "absolute",
        // top: "50%",
        backgroundColor: 'transparent',
        border: 'none',
        color: 'white',
        fontSize: '2rem',
        cursor: 'pointer'
    };

    const prevBtnStyles = {
        ...btnStyles
        // left: 0,
        // transform: "translateY(-50%)",
    };

    const nextBtnStyles = {
        ...btnStyles
        // right: 0,
        // transform: "translateY(-50%)",
    };

    // const deleteBtnStyles = {
    //     backgroundColor: "#ddd",
    //     borderRadius: "50%",
    //     width: "40px",
    //     height: "40px",
    //     display: "flex",
    //     alignItems: "center",
    //     justifyContent: "center",
    //     cursor: "pointer",
    //     position: "absolute",
    //     bottom: "10px",
    //     left: "50%",
    //     transform: "translateX(-50%)",
    // };

    return (
        <div className="slider" style={sliderStyles}>
            {sliderImages.length > 1 && (
                <button onClick={handlePrevSlide} style={prevBtnStyles}>
                    &lt;
                </button>
            )}
            {sliderImages.length > 0 && sliderImages[currentSlide] && (
                <img
                    onClick={() => {
                        setPreviewImage(images[currentSlide]);
                        setPreviewShown(true);
                    }}
                    src={images[currentSlide]}
                    alt={`Slide ${currentSlide + 1}`}
                    style={imgStyles}
                />
            )}
            {sliderImages.length === 0 && (
                <label className="handwai-text-label-normal">{'Keine Bilder vorhanden'}</label>
            )}
            {sliderImages.length > 1 && (
                <button onClick={handleNextSlide} style={nextBtnStyles}>
                    &gt;
                </button>
            )}

            {/*{isOrigin && sliderImages.length > 1 && (<div onClick={handleDeleteSlide} style={deleteBtnStyles}>*/}
            {/*    <span>-</span>*/}
            {/*</div>)}*/}
        </div>
    );
};

export default StundenImageSliderComponent;
